exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-edit-container {\n    width: 200px;\n    display: inline-block;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/dialogs/solutions-edit-table/solutions-edit-table.component.css
// module id = ../../../../../src/app/dialogs/solutions-edit-table/solutions-edit-table.component.css
// module chunks = main